import React, { useState, useEffect } from "react"
import PageLayout from "../layout/page-layout"
import DashboardModal from "./dashboard-modal"
import TextAlertsModal from "./text-alert-modal"
import { useStaticQuery, graphql } from "gatsby"
import CompetitonCard from "./competition-card"

import competitionStyles from "./competitions.module.scss"

const categories = ["class", "festival", "showcase", "competition", "museum"]

const Competitions = () => {
  // ! Filters
  const [categoryFilterValue, setCategoryFilterValue] = useState("")
  const [filterState, setFilterState] = useState("")

  // ! Modals
  const [showDashboadModal, setShowDashboardModal] = useState(false)
  const [showTextAlertModal, setShowTextAlertModal] = useState(false)

  const toggleDashboardModal = () => {
    setShowDashboardModal(prevState => !prevState)
  }

  const toggleTextAlertsModal = () => {
    setShowTextAlertModal(prevState => !prevState)
  }

  const handleDisplayedModal = () => {
    localStorage.setItem("displayedModal", "true")
  }

  // ! Query post data
  const postData = useStaticQuery(graphql`
    query {
      allMarkdownRemark {
        edges {
          node {
            id
            html
            excerpt
            fields {
              slug
            }
            frontmatter {
              title
              dateAndTime
              address
              price
              type
              by
              website
              state
              featuredImg {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  // ! Generate select for categories
  const renderCategorySelect = () => {
    const categoryOptions = categories.map(category => (
      <option key={category} value={category}>
        {category}
      </option>
    ))

    return (
      <select
        onChange={e => {
          setCategoryFilterValue(e.target.value)
        }}
      >
        <option value="">All Categories</option>
        {categoryOptions}
      </select>
    )
  }

  // ! Generate select for states
  const renderStateSelect = () => {
    const stateOptions = postData.allMarkdownRemark.edges
      // Filter out all duplicate states
      .reduce((arr, edge) => {
        const state = edge.node.frontmatter.state
        return arr.includes(state) ? arr : [...arr, state]
      }, [])
      // Create option with state as value
      .map(state => (
        <option key={state} value={state}>
          {state}
        </option>
      ))

    useEffect(() => {
      // ! Show modal after short delay
      const displayedModal = JSON.parse(localStorage.getItem("displayedModal"))

      if (!displayedModal) {
        setTimeout(() => {
          handleDisplayedModal()
          setShowDashboardModal(true)
        }, 4000)
      }
    }, [])
    return (
      <select
        onChange={e => {
          setFilterState(e.target.value)
        }}
      >
        <option value="">All States</option>
        {stateOptions}
      </select>
    )
  }

  // ! Generate posts
  const posts = postData.allMarkdownRemark.edges
    .filter(
      edge =>
        edge.node.frontmatter.type.includes(categoryFilterValue) &&
        edge.node.frontmatter.state.includes(filterState)
    )
    .map((edge, i) => {
      const { id, html, excerpt, fields } = edge.node
      const {
        title,
        dateAndTime,
        address,
        price,
        by,
        type,
        website,
        featuredImg,
      } = edge.node.frontmatter

      return (
        <CompetitonCard
          key={id}
          title={title}
          dateAndTime={dateAndTime}
          address={address}
          price={price}
          by={by}
          website={website}
          excerpt={excerpt}
          slug={fields.slug}
          imageData={featuredImg.childImageSharp.fluid}
        />
      )
    })

  return (
    <PageLayout title="Competitions">
      <div className={competitionStyles.filters}>
        {renderStateSelect()}
        {renderCategorySelect()}
      </div>

      <div className={competitionStyles.posts}>
        {posts.length > 0 ? posts : <p>Nothing to display</p>}
      </div>

      {/* <button
        onClick={toggleTextAlertsModal}
        className={competitionStyles.textAlertsButton}
      >
        Get Competition Alerts
      </button> */}
      {showDashboadModal && (
        <DashboardModal toggleDashboardModal={toggleDashboardModal} />
      )}
      {/* {showTextAlertModal && (
        <TextAlertsModal toggleTextAlertsModal={toggleTextAlertsModal} />
      )} */}
    </PageLayout>
  )
}

export default Competitions
